import React from 'react'
import CaseStudyQuote from './CaseStudyQuote'

const CaseStudyQuotes = (props) => {
    return (
        <div id="cs-quotes">
            <h4 className="casestudies">{i18njs["Resource.Quotes"]}</h4>

            {props.Quotes.map((q) => (
                <CaseStudyQuote key={q.QuoteOrder} Quote={q.QuoteText} QuoteSource={q.QuoteSource} />
            ))}
        </div>
    )
}

export default CaseStudyQuotes